import type { ReactNode } from 'react'

import { Header } from '@/components/layout/header'
import { Footer } from '@/components/layout/footer'

interface AppLayoutProps {
  children: ReactNode
}

function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex min-h-svh flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}

export { AppLayout }
